module.exports = __webpack_public_path__ + "da68340d7c0c2f4fd0fffb91897fe1f6.png";